import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCGrayAnalytics(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 442 482">
            <defs>
                <clipPath id="clip-path">
                    <path
                        id="Path_42"
                        data-name="Path 42"
                        d="M422.55,329.61a30.42,30.42,0,1,1-35.35,24.52A30.42,30.42,0,0,1,422.55,329.61Z"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                </clipPath>
            </defs>
            <g id="analytics" transform="translate(1.5 1.5)">
                <g id="Layer_1" data-name="Layer 1" transform="translate(-3.92 -32.51)">
                    <circle
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        cx="214.03"
                        cy="214.03"
                        r="214.03"
                        transform="translate(20.22 32.51)"
                        fill="#fff"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_1"
                        data-name="Path 1"
                        d="M210,180.67a19.29,19.29,0,0,0-12.23-4.35H68a20.34,20.34,0,0,0-20.34,20.34V366.59H13.18V383.2A16.33,16.33,0,0,0,28,399.47H165.94a20.33,20.33,0,0,0,18.63-20.26V205.05h32.61v-9.36A19.32,19.32,0,0,0,210,180.67Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_1"
                        data-name="Rectangle 1"
                        width="92.43"
                        height="127.29"
                        rx="14.38"
                        transform="translate(350.79 272.22)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_2"
                        data-name="Rectangle 2"
                        width="92.43"
                        height="127.29"
                        rx="14.38"
                        transform="translate(344.47 272.22)"
                        fill="#fff"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_3"
                        data-name="Rectangle 3"
                        width="76.52"
                        height="94.27"
                        transform="translate(352.29 284.84)"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_2"
                        data-name="Path 2"
                        d="M390.55,384.39a4.23,4.23,0,1,0,4.22,4.22A4.23,4.23,0,0,0,390.55,384.39Z"
                        fill="#fff"
                        stroke="#444"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M364.67,324.75a25,25,0,1,0,7.322-17.728A25,25,0,0,0,364.67,324.75Z"
                        fill="#707171"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M389.72,324.75V297.26a27.82,27.82,0,0,1,27.83,27.49Z"
                        fill="#f4f5f6"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M414.77,324.59v.16a25.05,25.05,0,0,1-50.1,0v-.16Z"
                        fill="#e3e2e3"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M389.72,324.62l21.08-21.09a30.19,30.19,0,0,1,.26,42.43Z"
                        fill="#707171"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_7"
                        data-name="Path 7"
                        d="M389.71,324.77l-12.52,24.48a27.83,27.83,0,0,1-12.26-37.15Z"
                        fill="#f4f5f6"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_8"
                        data-name="Path 8"
                        d="M389.74,324.59l8.94,27.68a29.44,29.44,0,0,1-36.94-18.63Z"
                        fill="#e3e2e3"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_9"
                        data-name="Path 9"
                        d="M379.87,324.59a9.85,9.85,0,1,0,9.85-9.84A9.85,9.85,0,0,0,379.87,324.59Z"
                        fill="#e3e2e3"
                        stroke="#444"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_4"
                        data-name="Rectangle 4"
                        width="50.78"
                        height="3.15"
                        transform="translate(361.62 363.47)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_5"
                        data-name="Rectangle 5"
                        width="42.81"
                        height="3.15"
                        transform="translate(361.62 369.1)"
                        fill="#fff"
                    />
                    <path
                        id="Path_10"
                        data-name="Path 10"
                        d="M339.92,240.3c-9.78,0-8.28,7.28-8.28,17.05V381.78a17.75,17.75,0,0,0,17.73,17.73h13.72c9.46-2.65,16-8.91,16-20.15V376H360.38V253.22a12.92,12.92,0,0,0-12.92-12.92Z"
                        fill="#939598"
                        opacity="0.35"
                    />
                    <path
                        id="Path_11"
                        data-name="Path 11"
                        d="M175.32,194.16a16.31,16.31,0,0,1,25.46-13.49,19.26,19.26,0,0,0-12.22-4.35H58.77a20.34,20.34,0,0,0-20.34,20.34V399.51H155a20.34,20.34,0,0,0,20.34-20.34v-185Z"
                        fill="#fff"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_12"
                        data-name="Path 12"
                        d="M175.32,194.16v2h32.61v-.49a19.33,19.33,0,0,0-7.15-15,16.31,16.31,0,0,0-25.46,13.49Z"
                        fill="#efefef"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_6"
                        data-name="Rectangle 6"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 223.39)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_7"
                        data-name="Rectangle 7"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 240.21)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_8"
                        data-name="Rectangle 8"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 257.02)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_9"
                        data-name="Rectangle 9"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 206.58)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_10"
                        data-name="Rectangle 10"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 273.83)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_11"
                        data-name="Rectangle 11"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 290.64)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_12"
                        data-name="Rectangle 12"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 307.44)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_13"
                        data-name="Rectangle 13"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 324.25)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_14"
                        data-name="Rectangle 14"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 324.25)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_15"
                        data-name="Rectangle 15"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 341.06)"
                        fill="#cdced1"
                    />
                    <rect
                        id="Rectangle_16"
                        data-name="Rectangle 16"
                        width="7.92"
                        height="3.53"
                        transform="translate(131.68 357.87)"
                        fill="#cdced1"
                    />
                    <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M148.92,201.3h-5.2V382.13l5.2,2.79Z"
                        fill="#cdced1"
                    />
                    <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M141.21,383.2V366.59H3.92V383.2a16.34,16.34,0,0,0,14.812,16.27H157.51a16.26,16.26,0,0,1-16.3-16.27Z"
                        fill="#fff"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_17"
                        data-name="Rectangle 17"
                        width="4.02"
                        height="5.08"
                        transform="translate(64.3 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_18"
                        data-name="Rectangle 18"
                        width="4.02"
                        height="5.08"
                        transform="translate(55.16 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_19"
                        data-name="Rectangle 19"
                        width="4.03"
                        height="5.08"
                        transform="translate(46.02 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_20"
                        data-name="Rectangle 20"
                        width="4.02"
                        height="5.08"
                        transform="translate(36.88 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_21"
                        data-name="Rectangle 21"
                        width="4.03"
                        height="5.08"
                        transform="translate(27.74 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_22"
                        data-name="Rectangle 22"
                        width="4.02"
                        height="5.08"
                        transform="translate(18.6 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_23"
                        data-name="Rectangle 23"
                        width="4.02"
                        height="5.08"
                        transform="translate(9.46 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_24"
                        data-name="Rectangle 24"
                        width="4.02"
                        height="5.08"
                        transform="translate(119.14 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_25"
                        data-name="Rectangle 25"
                        width="4.02"
                        height="5.08"
                        transform="translate(110 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_26"
                        data-name="Rectangle 26"
                        width="4.02"
                        height="5.08"
                        transform="translate(128.28 374.33)"
                        fill="#b0b3b7"
                    />
                    <rect
                        id="Rectangle_27"
                        data-name="Rectangle 27"
                        width="4.03"
                        height="5.08"
                        transform="translate(100.86 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_28"
                        data-name="Rectangle 28"
                        width="4.02"
                        height="5.08"
                        transform="translate(91.72 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_29"
                        data-name="Rectangle 29"
                        width="4.03"
                        height="5.08"
                        transform="translate(82.58 374.33)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_30"
                        data-name="Rectangle 30"
                        width="4.02"
                        height="5.08"
                        transform="translate(73.44 374.33)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_15"
                        data-name="Path 15"
                        d="M81.23,221c-8.08-7.51,3.27-19.76,11.37-12.24S89.32,228.44,81.23,221Zm2.16-2.33c5,4.6,12.08-2.89,7-7.58s-11.96,2.91-7,7.53Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_16"
                        data-name="Path 16"
                        d="M76.19,286.79C70,277.68,83.76,268.25,90,277.36S82.42,295.9,76.19,286.79Zm2.63-1.8c3.85,5.64,12.39-.19,8.53-5.83S75,279.35,78.82,285Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_17"
                        data-name="Path 17"
                        d="M52,314.87c-6.23-9.12,7.56-18.54,13.79-9.43S58.27,324,52,314.87Zm2.63-1.8c3.85,5.64,12.39-.2,8.53-5.84s-12.35.2-8.49,5.84Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_18"
                        data-name="Path 18"
                        d="M59.49,348.31c-6.23-9.11,7.56-18.54,13.79-9.43S65.72,357.41,59.49,348.31Zm2.63-1.8c3.86,5.64,12.39-.19,8.53-5.84s-12.39.19-8.53,5.84Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_19"
                        data-name="Path 19"
                        d="M69.51,252.34c-6.23-9.11,7.55-18.53,13.77-9.43S75.74,261.45,69.51,252.34Zm2.61-1.79c3.86,5.63,12.4-.19,8.54-5.84S68.27,244.91,72.12,250.55Z"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_31"
                        data-name="Rectangle 31"
                        width="25.22"
                        height="6.36"
                        transform="translate(84.364 344.347) rotate(-85.2)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_32"
                        data-name="Rectangle 32"
                        width="6.36"
                        height="20.9"
                        transform="matrix(0.974, -0.228, 0.228, 0.974, 57.523, 317.191)"
                        fill="#707171"
                    />
                    <path
                        id="Path_20"
                        data-name="Path 20"
                        d="M65.64,306.31l-4.73-4.27,15.27-16.95,4.73,4.27Z"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_33"
                        data-name="Rectangle 33"
                        width="6.36"
                        height="21.8"
                        transform="translate(74.902 254.545) rotate(-12.08)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_34"
                        data-name="Rectangle 34"
                        width="21.18"
                        height="6.36"
                        transform="translate(75.941 240.434) rotate(-75.29)"
                        fill="#707171"
                    />
                    <path
                        id="Path_21"
                        data-name="Path 21"
                        d="M115.04,285.45l-10.09-13.34,5.09-3.83,10.08,13.33Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_35"
                        data-name="Rectangle 35"
                        width="16.11"
                        height="6.36"
                        transform="translate(101.355 256.002) rotate(-73.3)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_22"
                        data-name="Path 22"
                        d="M96.92,310.34l-3.7-5.18,21.23-15.15,3.69,5.18Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M80.16,356.32c-6.23-9.11,7.56-18.53,13.79-9.42S86.39,365.43,80.16,356.32Zm4-9A5.181,5.181,0,1,0,90,355.88c5.6-3.88-.22-12.4-5.86-8.54Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_24"
                        data-name="Path 24"
                        d="M82.91,317.36c-6.23-9.12,7.55-18.54,13.78-9.43S89.13,326.46,82.91,317.36Zm4-9a5.17,5.17,0,0,0,5.83,8.53c5.6-3.83-.21-12.37-5.86-8.51Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_25"
                        data-name="Path 25"
                        d="M126.44,295.78C117.33,302,107.89,288.22,117,282S135.55,289.56,126.44,295.78Zm-7.63-11.16c-5.64,3.86.18,12.39,5.83,8.53s-.19-12.38-5.83-8.53Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M107.61,271.08c-9.1,6.22-18.53-7.56-9.42-13.78S116.73,264.85,107.61,271.08ZM100,259.92c-5.63,3.85.2,12.39,5.84,8.54S105.63,256.05,100,259.92Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_27"
                        data-name="Path 27"
                        d="M102.89,239.51c-6.23-9.11,7.55-18.53,13.78-9.42S109.12,248.62,102.89,239.51Zm2.62-1.79c3.85,5.63,12.39-.19,8.53-5.84S101.65,232.08,105.51,237.72Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_28"
                        data-name="Path 28"
                        d="M129.11,251a10.64,10.64,0,0,1,10.64-10.65H341.36A10.65,10.65,0,0,1,352,251V377.19H129.1Z"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_29"
                        data-name="Path 29"
                        d="M113.85,377.19v4.61c0,12.84,10.41,17.71,23.24,17.71H344c12.84,0,23.24-4.87,23.24-17.71v-4.61Z"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_36"
                        data-name="Rectangle 36"
                        width="194.83"
                        height="112.24"
                        transform="translate(144.46 257.41)"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <rect
                        id="Rectangle_37"
                        data-name="Rectangle 37"
                        width="24.55"
                        height="2.36"
                        transform="translate(181.85 278.95)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_38"
                        data-name="Rectangle 38"
                        width="38.02"
                        height="2.36"
                        transform="translate(181.85 283.92)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_39"
                        data-name="Rectangle 39"
                        width="32.05"
                        height="2.36"
                        transform="translate(181.85 288.89)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_40"
                        data-name="Rectangle 40"
                        width="15.28"
                        height="18.25"
                        transform="translate(182.66 335.51)"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_41"
                        data-name="Rectangle 41"
                        width="15.28"
                        height="28.83"
                        transform="translate(205.45 324.93)"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_42"
                        data-name="Rectangle 42"
                        width="15.28"
                        height="38.65"
                        transform="translate(228.25 315.11)"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_43"
                        data-name="Rectangle 43"
                        width="15.28"
                        height="34.14"
                        transform="translate(251.05 319.62)"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_44"
                        data-name="Rectangle 44"
                        width="15.28"
                        height="55.41"
                        transform="translate(273.84 298.35)"
                        fill="#f4f5f6"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_45"
                        data-name="Rectangle 45"
                        width="15.28"
                        height="79.09"
                        transform="translate(296.64 274.68)"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_46"
                        data-name="Rectangle 46"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 279.62)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_47"
                        data-name="Rectangle 47"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 291.87)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_48"
                        data-name="Rectangle 48"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 304.11)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_49"
                        data-name="Rectangle 49"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 316.36)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_50"
                        data-name="Rectangle 50"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 328.6)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_51"
                        data-name="Rectangle 51"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 340.84)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_52"
                        data-name="Rectangle 52"
                        width="5.47"
                        height="2.44"
                        transform="translate(165.99 353.08)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_30"
                        data-name="Path 30"
                        d="M188.34,317.24l15.7-13,7,8.44,23.52-19.74,11.12,13.59,28.47-23.7"
                        fill="none"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M175.04,279.63V354.4H316.35"
                        fill="none"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_53"
                        data-name="Rectangle 53"
                        width="13.46"
                        height="20.33"
                        transform="translate(447.784 376.983) rotate(-71.37)"
                        fill="#fff"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_32"
                        data-name="Path 32"
                        d="M429.51,322.84a38.73,38.73,0,1,1-49.07,24.33,38.73,38.73,0,0,1,49.07-24.33Z"
                        fill="#fff"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_33"
                        data-name="Path 33"
                        d="M426.76,331a30.12,30.12,0,1,1-38.16,18.92A30.12,30.12,0,0,1,426.76,331Z"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_34"
                        data-name="Path 34"
                        d="M501.48,376.43a10.921,10.921,0,0,1-7,20.69l-27.56-9.26a3.3,3.3,0,0,1-2.07-4.18l4.87-14.44a3.3,3.3,0,0,1,4.18-2.07Z"
                        fill="#e3e2e3"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_35"
                        data-name="Path 35"
                        d="M422.55,329.61a30.42,30.42,0,1,1-35.35,24.52A30.42,30.42,0,0,1,422.55,329.61Z"
                        fill="#e3e2e3"
                    />
                    <g id="Group_1" data-name="Group 1" clipPath="url(#clip-path)">
                        <path
                            id="Path_36"
                            data-name="Path 36"
                            d="M389.57,334.35,385,290.92a44.21,44.21,0,0,1,48.54,38.8Z"
                            fill="#36b8d1"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="6"
                        />
                        <path
                            id="Path_37"
                            data-name="Path 37"
                            d="M429.11,329.94v.25A39.79,39.79,0,1,1,350,338.51a1.769,1.769,0,0,1,0-.24Z"
                            fill="#f4f5f6"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="3"
                        />
                        <path
                            id="Path_38"
                            data-name="Path 38"
                            d="M389.55,334.15l29.8-36.82a48,48,0,0,1,7.46,67Z"
                            fill="#707171"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="3"
                        />
                        <path
                            id="Path_39"
                            data-name="Path 39"
                            d="M389.56,334.39l-15.72,40.76a44.23,44.23,0,0,1-25.53-56.66Z"
                            fill="#f0777e"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="6"
                        />
                        <path
                            id="Path_40"
                            data-name="Path 40"
                            d="M389.58,334.1l18.72,42.23a46.75,46.75,0,0,1-61.46-23.28Z"
                            fill="#e3e2e3"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="3"
                        />
                        <path
                            id="Path_41"
                            data-name="Path 41"
                            d="M374,335.74a15.64,15.64,0,1,0,13.92-17.19A15.64,15.64,0,0,0,374,335.74Z"
                            fill="#e3e2e3"
                            stroke="#444"
                            strokeMiterlimit="10"
                            strokeWidth="3"
                        />
                    </g>
                    <path
                        id="Path_43"
                        data-name="Path 43"
                        d="M422.55,329.61a30.42,30.42,0,1,1-35.35,24.52A30.42,30.42,0,0,1,422.55,329.61Z"
                        fill="none"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_1"
                        data-name="Line 1"
                        x1="68.53"
                        transform="translate(151.74 113.38)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_2"
                        data-name="Line 2"
                        x1="59.07"
                        transform="translate(162.52 151.13)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        strokeDasharray="2"
                    />
                    <line
                        id="Line_3"
                        data-name="Line 3"
                        x1="30.31"
                        transform="translate(230.73 113.38)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_44"
                        data-name="Path 44"
                        d="M200.7,220.24l5.37,5.38,11.11-11.11"
                        fill="none"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_45"
                        data-name="Path 45"
                        d="M273.24,429.18l5.38,5.38,11.1-11.11"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_4"
                        data-name="Line 4"
                        x1="14.18"
                        transform="translate(97.86 116.49)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_5"
                        data-name="Line 5"
                        y1="14.18"
                        transform="translate(104.95 109.4)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_6"
                        data-name="Line 6"
                        x1="14.18"
                        transform="translate(168.23 68.54)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_7"
                        data-name="Line 7"
                        y1="14.17"
                        transform="translate(175.32 61.46)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_8"
                        data-name="Line 8"
                        x1="14.18"
                        transform="translate(315.79 417.89)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_9"
                        data-name="Line 9"
                        y1="14.17"
                        transform="translate(322.88 410.81)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_10"
                        data-name="Line 10"
                        x1="10.02"
                        y1="10.02"
                        transform="translate(320.74 181.98)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_11"
                        data-name="Line 11"
                        y1="10.02"
                        x2="10.02"
                        transform="translate(320.74 181.98)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_12"
                        data-name="Line 12"
                        x2="68.54"
                        transform="translate(159.21 425.03)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_13"
                        data-name="Line 13"
                        x2="30.31"
                        transform="translate(206.35 435.86)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_14"
                        data-name="Line 14"
                        x2="30.32"
                        transform="translate(160.48 414.2)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_15"
                        data-name="Line 15"
                        x2="30.31"
                        transform="translate(286.9 143.22)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_16"
                        data-name="Line 16"
                        x2="33.03"
                        transform="translate(126.87 163.01)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_17"
                        data-name="Line 17"
                        x1="0.76"
                        transform="translate(399.8 187.02)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_18"
                        data-name="Line 18"
                        x1="61.81"
                        transform="translate(336.5 187.02)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        strokeDasharray="1.96 1.96"
                    />
                    <line
                        id="Line_19"
                        data-name="Line 19"
                        x1="0.76"
                        transform="translate(335 187.02)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_20"
                        data-name="Line 20"
                        x1="33.21"
                        transform="translate(329.65 218.62)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <line
                        id="Line_21"
                        data-name="Line 21"
                        x1="38.51"
                        transform="translate(208.41 94.29)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        strokeDasharray="2"
                    />
                    <rect
                        id="Rectangle_54"
                        data-name="Rectangle 54"
                        width="6.37"
                        height="9.6"
                        transform="translate(394.37 242.36)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_55"
                        data-name="Rectangle 55"
                        width="6.37"
                        height="21.4"
                        transform="translate(405.59 230.57)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_56"
                        data-name="Rectangle 56"
                        width="6.37"
                        height="17.68"
                        transform="translate(416.82 234.29)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <rect
                        id="Rectangle_57"
                        data-name="Rectangle 57"
                        width="6.37"
                        height="27.53"
                        transform="translate(428.05 224.44)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_46"
                        data-name="Path 46"
                        d="M438.18,251.97H389.5V221.39"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_47"
                        data-name="Path 47"
                        d="M367.25,132.69H322.88V115.94"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_48"
                        data-name="Path 48"
                        d="M350.79,128.58c-7.49-.51-7.76-12.25-8-23.61-.17-7.12-.37-16-3.07-16.21-2.69.24-2.9,9.09-3.06,16.21-.26,11.36-.53,23.1-8,23.61"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_49"
                        data-name="Path 49"
                        d="M365,128.59c-7.51,0-9-7.75-10-13.41-.79-4.22-1.43-7-3-7.09-1.59.08-2.24,2.87-3,7.09-1.05,5.66-2.5,13.41-10,13.41"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <path
                        id="Path_50"
                        data-name="Path 50"
                        d="M272.7,190.53h0l3,.95a.22.22,0,0,1,.12.11.2.2,0,0,1,0,.16l-.71,2.2.41.22a12.469,12.469,0,0,1,2.68,1.92l.34.33,1.85-1.36a.24.24,0,0,1,.14-.06.2.2,0,0,1,.16.11l1.83,2.5a.22.22,0,0,1,0,.3l-1.86,1.36.21.42a12.25,12.25,0,0,1,1,3.13l.09.46h2.28a.21.21,0,0,1,.21.21v3.1a.21.21,0,0,1-.06.15.18.18,0,0,1-.15.07H282l-.08.47a12.293,12.293,0,0,1-.41,1.64,11.208,11.208,0,0,1-.61,1.52l-.19.42,1.83,1.32a.313.313,0,0,1,.08.3L280.76,215a.22.22,0,0,1-.18.09.19.19,0,0,1-.12-.05l-1.82-1.31-.33.33a12.66,12.66,0,0,1-2.69,2l-.41.23.69,2.12a.21.21,0,0,1-.14.27l-3,1a.23.23,0,0,1-.21-.15l-.69-2.12-.46.06a12.783,12.783,0,0,1-1.69.12,12.1,12.1,0,0,1-1.65-.12l-.47-.06-.68,2.13a.21.21,0,0,1-.21.15l-3-1a.21.21,0,0,1-.14-.27l.68-2.13-.41-.22a12.19,12.19,0,0,1-2.7-2l-.34-.32L259,215.11a.28.28,0,0,1-.14.06c-.05,0-.1,0-.16-.11l-1.83-2.51a.18.18,0,0,1,0-.16.2.2,0,0,1,.08-.14l1.83-1.33-.2-.42a12.31,12.31,0,0,1-1-3.16l-.09-.46h-2.27a.22.22,0,0,1-.21-.22v-3.1a.21.21,0,0,1,.06-.15.27.27,0,0,1,.16-.06h2.27l.09-.46a11.992,11.992,0,0,1,.39-1.57,12.246,12.246,0,0,1,.63-1.57l.2-.42L256.83,198a.22.22,0,0,1,0-.3l1.81-2.51c.06-.08.11-.11.16-.11a.2.2,0,0,1,.14.06l1.86,1.34.34-.32a12.16,12.16,0,0,1,2.67-1.94l.41-.23-.72-2.18a.22.22,0,0,1,.14-.27l3-1a.22.22,0,0,1,.21.15l.72,2.19.46-.06a12.519,12.519,0,0,1,1.68-.12,11.571,11.571,0,0,1,1.61.11l.46.06.71-2.2a.23.23,0,0,1,.24-.14m-3,21.55a6.86,6.86,0,1,0-6.86-6.86,6.86,6.86,0,0,0,6.86,6.86m3-23.83h0a2.47,2.47,0,0,0-2.4,1.72l-.15.46h-1L269,190a2.49,2.49,0,0,0-2.37-1.72h-.36l-.34.11-3,1a2.51,2.51,0,0,0-1.61,3.13l.15.46c-.28.2-.56.4-.82.61l-.38-.28a2.48,2.48,0,0,0-1.48-.49,2.44,2.44,0,0,0-2,1.05l-1.82,2.52a2.49,2.49,0,0,0,.55,3.47l.38.28-.18.51c-.05.16-.1.31-.14.47h-.45a2.49,2.49,0,0,0-2.49,2.52v3.08a2.5,2.5,0,0,0,2.49,2.49h.45c.09.33.2.66.32,1l-.35.25a2.49,2.49,0,0,0-.55,3.47l1.84,2.52a2.43,2.43,0,0,0,3.49.54l.33-.24a10.25,10.25,0,0,0,.85.62l-.12.39a2.47,2.47,0,0,0,1.62,3.14l3,1,.34.11h.35a2.5,2.5,0,0,0,2.37-1.71l.13-.4h1.06l.13.38a2.5,2.5,0,0,0,2.37,1.71h.36l.34-.11,3-1a2.51,2.51,0,0,0,1.45-1.26,2.46,2.46,0,0,0,.14-1.9l-.12-.38c.29-.2.58-.41.86-.63l.33.24a2.46,2.46,0,0,0,1.45.47,2.49,2.49,0,0,0,2-1l1.83-2.53a2.51,2.51,0,0,0,.44-1.88,2.45,2.45,0,0,0-1-1.6l-.36-.26c.06-.15.11-.31.16-.46s.11-.35.16-.53h.43a2.51,2.51,0,0,0,2.49-2.52v-3.09a2.49,2.49,0,0,0-2.49-2.48h-.47c-.09-.33-.2-.65-.32-1l.37-.27a2.49,2.49,0,0,0,.55-3.47l-1.84-2.52a2.45,2.45,0,0,0-3.47-.55l-.39.29c-.27-.21-.55-.41-.83-.6l.14-.45a2.48,2.48,0,0,0-1.6-3.13l-3-1-.27-.09h-.46Zm-3,21.55a4.58,4.58,0,1,1,4.58-4.58,4.58,4.58,0,0,1-4.58,4.58Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_51"
                        data-name="Path 51"
                        d="M258.4,180.25a.61.61,0,0,1-.21-.62,8.572,8.572,0,0,0,.19-1.77,8.67,8.67,0,0,0-.19-1.78.61.61,0,0,1,.21-.62l2.66-1.93a.38.38,0,0,0,.08-.53L258,168.7a.39.39,0,0,0-.54-.08l-2.56,1.86a.59.59,0,0,1-.66,0,8.74,8.74,0,0,0-3.54-1.23.58.58,0,0,1-.51-.4l-1-2.89a.38.38,0,0,0-.47-.25l-5.06,1.65a.37.37,0,0,0-.24.48l.88,2.73a.49.49,0,0,1-.12.55,8.65,8.65,0,0,0-2.52,3.3.6.6,0,0,1-.54.41h-2.78a.38.38,0,0,0-.38.38v5.31a.38.38,0,0,0,.38.38h2.78a.51.51,0,0,1,.49.3,8.89,8.89,0,0,0,2.47,3.34.57.57,0,0,1,.22.63l-.88,2.73a.38.38,0,0,0,.24.48l5.06,1.64a.38.38,0,0,0,.47-.25l1-2.89a.63.63,0,0,1,.56-.41,8.52,8.52,0,0,0,3.52-1.24.58.58,0,0,1,.63,0l2.56,1.86A.38.38,0,0,0,258,187l3.12-4.3a.38.38,0,0,0-.08-.53Z"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="1"
                    />
                    <circle
                        id="Ellipse_2"
                        data-name="Ellipse 2"
                        cx="3.23"
                        cy="3.23"
                        r="3.23"
                        transform="translate(246.39 174.63)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_52"
                        data-name="Path 52"
                        d="M274.15,290.08l.23-6.9h0a.7.7,0,0,0-.71-.71h0l-6.89.23"
                        fill="none"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <circle
                        id="Ellipse_3"
                        data-name="Ellipse 3"
                        cx="8.97"
                        cy="8.97"
                        r="8.97"
                        transform="translate(53.69 145.81)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_4"
                        data-name="Ellipse 4"
                        cx="8.97"
                        cy="8.97"
                        r="8.97"
                        transform="translate(375.87 145.81)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_5"
                        data-name="Ellipse 5"
                        cx="8.97"
                        cy="8.97"
                        r="8.97"
                        transform="translate(270.57 61.27)"
                        fill="none"
                        stroke="#e3e2e3"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <ellipse
                        id="_Path_"
                        data-name="&lt;Path&gt;"
                        cx="131.93"
                        cy="12.95"
                        rx="131.93"
                        ry="12.95"
                        transform="translate(102.32 474.59)"
                        fill="#f4f5f6"
                    />
                </g>
            </g>
        </SVGIcon>
    );
}
